import React from 'react';
import SwiperCore, {Autoplay} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react/swiper-react.js';
import 'swiper/swiper.min.css'; // core Swiper
import 'swiper/modules/navigation/navigation.min.css'; // Navigation module
import 'swiper/modules/pagination/pagination.min.css'; // Pagination module
import './style.css';

import { Pagination } from 'swiper';
import { Image } from '@chakra-ui/react';

const Carousel = (props) => {
	SwiperCore.use([Autoplay]);
	return (
		<>
			<Swiper
				pagination={{
					dynamicBullets: true,
				}}
				modules={[Pagination, Autoplay]}
				autoplay={{
					delay: 5000,
				}}
				className="mySwiper"
				style={{ height: props.minH || props.img_height, minHeight: props.minH || props.img_height }}
			>
				{props.data?.map((item, key) => (
					<SwiperSlide key={item}>
						<Image width={'100%'} src={item} alt={`carousel-${key}-logo`} />
					</SwiperSlide>
				))}
			</Swiper>
		</>
	);
};

export default Carousel;
